import {
  ADD_GROUP,
  CHANGE_GROUPS,
  END_BULK_DELETE,
  END_BULK_TAGGING,
  END_DELETE_GROUPS,
  END_EDIT_GROUPS,
  START_BULK_DELETE,
  SET_BULK_TAGS,
  START_BULK_TAGGING,
  START_DELETE_GROUPS,
  START_EDIT_GROUPS,
  SHOW_MOVE_RECORDS_MODAL,
  HIDE_MOVE_RECORDS_MODAL,
  SHOW_COPY_RECORDS_MODAL,
  HIDE_COPY_RECORDS_MODAL
} from '../actions/properties';

export default function(state = {}, action) {
  switch (action.type) {
  case ADD_GROUP:
    return {
      ...state,
      groups: [...state.groups, action.group]
    };
  case END_EDIT_GROUPS:
    return {
      ...state,
      editingGroups: null
    };
  case END_BULK_DELETE:
    return {
      ...state,
      startBulkDelete: false
    };
  case END_BULK_TAGGING:
    return {
      ...state,
      startBulkTagging: false
    };
  case CHANGE_GROUPS:
    return {
      ...state,
      groups: action.groups
    };
  case START_BULK_DELETE:
    return {
      ...state,
      startBulkDelete: true
    };
  case START_EDIT_GROUPS:
    return {
      ...state,
      editingGroups: action.groups
    };
  case START_BULK_TAGGING:
    return {
      ...state,
      startBulkTagging: true,
      bulkTags: []
    };
  case END_DELETE_GROUPS:
    return {
      ...state,
      deletingGroups: null
    };
  case START_DELETE_GROUPS:
    return {
      ...state,
      deletingGroups: action.group
    };
  case SET_BULK_TAGS:
    return {
      ...state,
      bulkTags: action.tags
    };
  case SHOW_MOVE_RECORDS_MODAL:
    return {
      ...state,
      showMoveRecords: true
    };
  case HIDE_MOVE_RECORDS_MODAL:
    return {
      ...state,
      showMoveRecords: false
    };
  case SHOW_COPY_RECORDS_MODAL:
    return {
      ...state,
      showCopyRecords: true
    };
  case HIDE_COPY_RECORDS_MODAL:
    return {
      ...state,
      showCopyRecords: false
    };   
  }
  return { ...state };
}
